import { Component, Output, EventEmitter  } from '@angular/core';
import { ModalService } from '@core-lib/modules/modal-container';

@Component({
    selector: 'fraude-virement',
    templateUrl: './fraude-virement-alerte-modal.component.html',
    styleUrls: ['./fraude-virement-alerte-modal.component.scss'],
    standalone: false
})

  
  export class FraudeVirementAlerteModal {
    
    @Output() IsFraudeVirementConfirmed: EventEmitter<boolean> = new EventEmitter<boolean>();

    isCertified = false;

    constructor(private modalService: ModalService) {}
    
    onConfirm(): void {
        this.IsFraudeVirementConfirmed.emit(true);
    }

    onClose(): void {
        this.modalService.hide();
	}
  }